module.exports = new __parcel__URL__("project-issue-navigator-header-skeleton.tpl.7e712bab.svg").toString();